module.exports = __webpack_public_path__ + "static/1-f310e8ad180f0a832e3642132b552a73.webp";